import React from 'react';
import { View } from 'react-native';
import { router } from 'expo-router';
import { MoreCircle, TickCircle, More, CloseCircle } from 'iconsax-react-native';
import { Text, TouchableRipple, Button } from 'react-native-paper';
import RBSheet from "react-native-raw-bottom-sheet";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { MainContext } from '../../../contexts/MainContext';

export default function MyVisitReportCard({ data }){
  const myContext = React.useContext(MainContext);
  const refRBSheet = React.useRef();
  const insets = useSafeAreaInsets();
  const [deleteLoading, setDeleteLoading] = React.useState(false);

  const handlePresentModalPress = React.useCallback(() => {
    refRBSheet.current?.open();
  }, []);

  const deleteItem = () => {
    setDeleteLoading(true);
    axios.delete(`/panel/propertyVisit/delete/${data._id}`)
      .then((response) => {
        refRBSheet.current?.close();
        if(response.data.status) {         
          myContext.activateSnackbar(true, response.data.message);
        } else {
          myContext.activateSnackbar(true, response.data.message); 
        }
      })
      .catch(myContext.handleAxiosError)
      .finally(() => setDeleteLoading(false));
  }

  return (
    <>
      <View style={{ flex: 1, backgroundColor: '#fff', elevation: 2, borderRadius: 8, padding: 12, marginBottom: 8 }}>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          {
            data.statusShow === 'تایید شده' ?
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <TickCircle size="24" color="#3C9A4F" variant="Bold"/>
                <Text style={{ fontSize: 12, marginLeft: 8, color: '#3C9A4F' }}>تایید شده</Text>
              </View>
            :
              data.statusShow === 'در حال بررسی!' ?
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <MoreCircle size="24" color="#FFA200" variant="Bold"/>
                  <Text style={{ fontSize: 12, marginLeft: 8, color: '#FFA200' }}>در انتظار بررسی!</Text>
                </View>
              :
                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                  <CloseCircle size="24" color="#D61600" variant="Bold"/>
                  <Text style={{ fontSize: 12, marginLeft: 8, color: '#D61600' }}>رد شده</Text>
                  {data.reject !== '' && <Text style={{ marginLeft: 4, fontSize: 10, color: '#8D8F94' }}>({data.reject})</Text>}
                </View>
          }
          <TouchableRipple borderless onPress={handlePresentModalPress} style={{ width: 30, height: 30, alignItems: 'center', justifyContent: 'center', borderRadius: 30, marginRight: -5 }}><More size="20" style={{ transform: [{rotate: '45deg'}, {rotateZ: '0.785398rad'}] }} color="#5B5E63" variant="Outline"/></TouchableRipple>
        </View>
        <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>  
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <Text style={{ fontSize: 14, color: '#6C6B6A', marginRight: 8 }}>کد آگهی:</Text>
            <View style={{ width: 60, borderWidth: 1, borderColor: '#292D32', borderRadius: 6, justifyContent: 'center', alignItems: 'center' }}><Text style={{ fontFamily: 'IRANSans_Bold', fontSize: 14 }}>{data.post?.postId}</Text></View>
          </View>    
        </View>
        <View style={{ borderTopWidth: 1, borderTopColor: '#EBEBEB', marginTop: 8, paddingTop: 8, flexDirection: 'row', flexWrap: 'wrap' }}>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text style={{ fontSize: 12, color: '#8D8F94' }}>نام مشتری:</Text>
            <Text style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium' }}>{data.user?.name}</Text>
          </View>
          <View style={{ width: '50%', marginBottom: 8 }}>
            <Text style={{ fontSize: 12, color: '#8D8F94' }}>شماره مشتری:</Text>
            <Text style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium' }}>{data.user?.mobile}</Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text style={{ fontSize: 12, color: '#8D8F94' }}>تاریخ ثبت:</Text>
            <Text style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium' }}>{data.created_at}</Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text style={{ fontSize: 12, color: '#8D8F94' }}>تاریخ بروزرسانی:</Text>
            <Text style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium' }}>{data.updated_at}</Text>
          </View>
        </View>
        <View style={{ borderTopWidth: 1, borderTopColor: '#EBEBEB', marginTop: 8, paddingTop: 8 }}>
          <Text style={{ fontSize: 12, color: '#8D8F94' }}>توضیحات:</Text>
          <Text style={{ fontSize: 13, color: '#5B5E63', fontFamily: 'IRANSans_Medium' }}>{data.des}</Text>
        </View>
        <Button labelStyle={{ fontSize: 16, fontFamily: 'IRANSans_Medium' }} style={{ width: '100%', marginTop: 16, borderRadius: 48, backgroundColor: '#2B93F3' }}  mode="contained" onPress={() => router.push(`/visitReport/${data._id}`)}>ویرایش</Button>
      </View>
      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={120}
        customStyles={{
          container: {
            paddingBottom: insets.bottom
          },
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          },
          draggableIcon: {
            backgroundColor: "#555"
          }
        }}
      >
        <View style={{ paddingHorizontal: 20, paddingVertical: 8 }}>
          <TouchableRipple disabled={deleteLoading} rippleColor="rgba(0, 0, 0, .04)" onPress={deleteItem} style={{ width: '100%', height: 48, paddingHorizontal: 12, justifyContent: 'center' }}>
            <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium' }}>حذف</Text>
          </TouchableRipple>
        </View>
      </RBSheet>
    </>
  );
};